<template>
  <b-form-group :label="item.field.prompt">
    <b-form-select id="option" v-model="item.value"
                  :disabled="item.disabled"
                  :required="item.field.mandatory"
                  :state="isValid"
                  :options="fieldOptions">
      <template slot="first">
        <option value="" disabled>{{item.field.prompt}}</option>
      </template>
    </b-form-select>
    <b-form-invalid-feedback :state="isValid">{{errorMessage}}</b-form-invalid-feedback>
  </b-form-group>
</template>


<script>

export default {
  name: 'SelectListField',
  components: { },
  props: {
    item: { type: Object }
  },
  data () {
    return {
      isValid: null,
      errorMessage: ''
    }
  },
  watch: {
  },
  computed: {
    fieldOptions () {
      return this.item.field.options.map((o) => { return { text: o, value: o } })
    }
  },
  methods: {
    validate () {
      this.isValid = true
      this.errorMessage = ''
      if (this.item.field.mandatory && (this.item.value == null || this.item.value.length === 0)) {
        this.isValid = false
        this.errorMessage = 'Please complete'
      }
      return this.isValid
    },
    value () {
      return { field_name: this.item.field.field_name, string_value: this.item.value }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data_entry/SelectListField.vue